import { render, staticRenderFns } from "./wareTemplete.vue?vue&type=template&id=226b3669&scoped=true&"
import script from "./wareTemplete.vue?vue&type=script&lang=js&"
export * from "./wareTemplete.vue?vue&type=script&lang=js&"
import style0 from "./wareTemplete.vue?vue&type=style&index=0&id=226b3669&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b3669",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ALink: require('/app/components/aLink.vue').default,SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,Ware: require('/app/components/ware-view/ware.vue').default})
